import React from "react";
import { formatMoney, getStatusBadgeClass, getStatusLabel } from "./utils";

export default function ConsultationsManagerPanel({
  consultations,
  consultationsEnabled,
  consultantProfile,
  consultationForm,
  updateConsultationField,
  resetConsultationForm,
  savingConsultation,
  handleSaveConsultation,
  handleEditConsultation,
  handleDeleteConsultation,
  isAdmin,
  isAr,
  isMobile,
}) {
  return (
    <div className="card border-0 shadow-sm mb-4 provider-center__panel-card">
      <div className="card-body">
        <div className="pc-section-head mb-3">
          <div className="pc-section-head__left">
            <span className="pc-icon-box pc-icon-box--cyan">
              <i className="bi bi-chat-square-dots" />
            </span>
            <h5 className="mb-0">{isAr ? "إدارة الاستشارات" : "Manage consultations"}</h5>
          </div>
          <span className="badge text-bg-light">{consultations.length}</span>
        </div>

        {!consultationsEnabled ? (
          <div className="alert alert-warning mb-0">
            {isAr
              ? "قسم الاستشارات معطل حاليًا من الإدارة."
              : "The consultations section is currently disabled from admin settings."}
          </div>
        ) : !isAdmin && !consultantProfile ? (
          <div className="text-muted">
            {isAr
              ? "أرسل طلب اعتماد كمستشار أولًا، وبعد الموافقة ستتمكن من إضافة جلساتك هنا."
              : "Apply as a consultant first. Once approved, you will be able to submit consultations here."}
          </div>
        ) : !isAdmin && consultantProfile.status !== "approved" ? (
          <div className="text-muted">
            {isAr
              ? "ملف المستشار ما زال بانتظار موافقة الإدارة."
              : "Your consultant profile is still waiting for admin approval."}
          </div>
        ) : (
          <>
            <div className="alert alert-info">
              {isAr
                ? "يمكنك من هنا إنشاء الاستشارة أو تعديلها، وأي تعديل سيعيدها إلى المراجعة."
                : "You can create or update consultations here. Any change will send the item back to review."}
            </div>

            <form onSubmit={handleSaveConsultation}>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "عنوان الاستشارة بالعربية" : "Title Arabic"}</label>
                  <input
                    className="form-control"
                    value={consultationForm.titleAr}
                    onChange={(event) => updateConsultationField("titleAr", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "عنوان الاستشارة بالإنجليزية" : "Title English"}</label>
                  <input
                    className="form-control"
                    value={consultationForm.titleEn}
                    onChange={(event) => updateConsultationField("titleEn", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "وصف مختصر بالعربية" : "Short Description Arabic"}</label>
                  <textarea
                    rows="2"
                    className="form-control"
                    value={consultationForm.shortDescriptionAr}
                    onChange={(event) => updateConsultationField("shortDescriptionAr", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "وصف مختصر بالإنجليزية" : "Short Description English"}</label>
                  <textarea
                    rows="2"
                    className="form-control"
                    value={consultationForm.shortDescriptionEn}
                    onChange={(event) => updateConsultationField("shortDescriptionEn", event.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">{isAr ? "الوصف بالعربية" : "Description Arabic"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={consultationForm.descriptionAr}
                    onChange={(event) => updateConsultationField("descriptionAr", event.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">{isAr ? "الوصف بالإنجليزية" : "Description English"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={consultationForm.descriptionEn}
                    onChange={(event) => updateConsultationField("descriptionEn", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label">{isAr ? "السعر" : "Price"}</label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    className="form-control"
                    value={consultationForm.price}
                    onChange={(event) => updateConsultationField("price", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label">{isAr ? "المدة بالدقائق" : "Duration Minutes"}</label>
                  <input
                    type="number"
                    min="1"
                    className="form-control"
                    value={consultationForm.durationMinutes}
                    onChange={(event) => updateConsultationField("durationMinutes", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label">{isAr ? "نوع الجلسة" : "Meeting Provider"}</label>
                  <input
                    className="form-control"
                    value={consultationForm.meetingProvider}
                    onChange={(event) => updateConsultationField("meetingProvider", event.target.value)}
                    placeholder={isAr ? "Zoom أو Google Meet" : "Zoom or Google Meet"}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label">{isAr ? "التصنيف" : "Category"}</label>
                  <input
                    className="form-control"
                    value={consultationForm.category}
                    onChange={(event) => updateConsultationField("category", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-8">
                  <label className="form-label">{isAr ? "صورة الغلاف" : "Cover Image"}</label>
                  <input
                    className="form-control"
                    value={consultationForm.coverImage}
                    onChange={(event) => updateConsultationField("coverImage", event.target.value)}
                    placeholder={isAr ? "رابط الصورة أو اسم الملف" : "Image URL or stored filename"}
                  />
                </div>
                <div className="col-12 col-md-4 d-flex align-items-end">
                  <div className="form-check mb-2">
                    <input
                      id="provider-consultation-active"
                      type="checkbox"
                      className="form-check-input"
                      checked={consultationForm.isActive}
                      onChange={(event) => updateConsultationField("isActive", event.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="provider-consultation-active">
                      {isAr ? "الاستشارة نشطة" : "Consultation is active"}
                    </label>
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2 mt-3">
                <button className="btn btn-dark" type="submit" disabled={savingConsultation}>
                  {savingConsultation
                    ? isAr
                      ? "جارٍ الحفظ..."
                      : "Saving..."
                    : consultationForm.id
                      ? isAr
                        ? "تحديث وإعادة إرسال"
                        : "Update and Resubmit"
                      : isAr
                        ? "إرسال الاستشارة"
                        : "Submit Consultation"}
                </button>
                {consultationForm.id ? (
                  <button className="btn btn-outline-secondary" type="button" onClick={resetConsultationForm}>
                    {isAr ? "إلغاء" : "Cancel"}
                  </button>
                ) : null}
              </div>
            </form>

            <hr className="my-4" />

            {consultations.length === 0 ? (
              <div className="text-muted">
                {isAr ? "لا توجد استشارات مضافة حتى الآن." : "No consultations have been submitted yet."}
              </div>
            ) : isMobile ? (
              <div className="provider-center__mobile-list">
                {consultations.map((consultation) => (
                  <article className="provider-center__mobile-item" key={consultation.id}>
                    <div className="provider-center__mobile-head">
                      <div>
                        <div className="fw-semibold">
                          {consultation.titleEn || consultation.titleAr || `#${consultation.id}`}
                        </div>
                        <div className="small text-muted">
                          {formatMoney(consultation.price)}
                          {consultation.rejectionReason ? ` · ${consultation.rejectionReason}` : ""}
                        </div>
                      </div>
                      <span className={`badge rounded-pill ${getStatusBadgeClass(consultation.approvalStatus)}`}>
                        {getStatusLabel(consultation.approvalStatus, isAr)}
                      </span>
                    </div>
                    <div className="provider-center__mobile-grid">
                      <div>
                        <div className="small text-muted">{isAr ? "الحجوزات" : "Bookings"}</div>
                        <div>{consultation.bookingsCount}</div>
                      </div>
                      <div>
                        <div className="small text-muted">{isAr ? "المدة" : "Duration"}</div>
                        <div>{consultation.durationMinutes} {isAr ? "دقيقة" : "min"}</div>
                      </div>
                    </div>
                    <div className="provider-center__mobile-actions">
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleEditConsultation(consultation)}>
                        {isAr ? "تعديل" : "Edit"}
                      </button>
                      <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteConsultation(consultation)}>
                        {isAr ? "حذف" : "Delete"}
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>{isAr ? "الاستشارة" : "Consultation"}</th>
                      <th>{isAr ? "الحالة" : "Approval"}</th>
                      <th>{isAr ? "السعر" : "Price"}</th>
                      <th>{isAr ? "الحجوزات" : "Bookings"}</th>
                      <th>{isAr ? "الإجراءات" : "Actions"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {consultations.map((consultation) => (
                      <tr key={consultation.id}>
                        <td>
                          <div className="fw-semibold">
                            {consultation.titleEn || consultation.titleAr || `#${consultation.id}`}
                          </div>
                          <div className="small text-muted">
                            {(isAr ? consultation.shortDescriptionAr : consultation.shortDescriptionEn) ||
                              consultation.rejectionReason ||
                              consultation.slug}
                          </div>
                        </td>
                        <td>
                          <span className={`badge rounded-pill ${getStatusBadgeClass(consultation.approvalStatus)}`}>
                            {getStatusLabel(consultation.approvalStatus, isAr)}
                          </span>
                        </td>
                        <td>{formatMoney(consultation.price)}</td>
                        <td>{consultation.bookingsCount}</td>
                        <td>
                          <div className="d-flex gap-2 flex-wrap">
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleEditConsultation(consultation)}>
                              {isAr ? "تعديل" : "Edit"}
                            </button>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteConsultation(consultation)}>
                              {isAr ? "حذف" : "Delete"}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
